module.exports = __webpack_public_path__ + "static/media/exclaimation.548fba27.svg";